import React from "react";
import { Link } from "react-router-dom";

const Palettes = () => {
  let palettes = [
    { label: "matéralité", value: "materialite" },
    { label: "iconographie", value: "iconographie" },
  ];

  return (
    <div>
      {/* <div id="retour" style={{ margin: "5px" }}>
        <Link to="/">retour</Link>
      </div>
      <header>Palettes disponibles</header> */}
      <div id="list">
        <ul>
          {palettes.map((item, index) => (
            <li key={index}>
              <Link to={`/palettes/${item.value}`}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Palettes;
